import style from '../../styles/TextInput.module.css'

export interface ITextInputProps {
  value: string;
  labelText: string;
  placeholderText?: string;
  readOnly?: boolean;
  failedValidation?: boolean;
  onChange?: (newValue: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  containerProps?: React.HTMLAttributes<HTMLDivElement>;
}

/**
 * A single line text input.
 * @returns
 */
export const TextInput = (props: ITextInputProps) => {
  return (
    <div className={`flex-column ${style.inputFieldContainer} ${props.inputProps?.required ? style.required : ''} ${props.failedValidation === true ? style.validationError : ''}`} {...props.containerProps}>
      <InputLabel labelText={props.labelText} />
      <input 
        className={`${style.fieldInput} ${props.failedValidation === true ? style.validationError : ''}`}
        placeholder={props.placeholderText ?? props.labelText}
        value={props.value}
        disabled={props.readOnly}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange(e.target.value)
          }
        }}
        onKeyDown={(e) => {
          if (props.onKeyDown) {
            props.onKeyDown(e)
          }
        }}
        {...props.inputProps}
      />
    </div>
  )
}

export interface ITextAreaInputProps {
  value: string;
  labelText: string;
  placeholderText?: string;
  readOnly?: boolean;
  onChange?: (newValue: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  style?: React.CSSProperties | undefined;
}

export const MultilineTextInput = (props: ITextAreaInputProps): JSX.Element => {
  return (
    <div className='flex-column' style={{width: '100%'}}>
      <InputLabel labelText={props.labelText} />
      <textarea 
        className={style.fieldInput}
        placeholder={props.placeholderText ?? props.labelText}
        value={props.value}
        disabled={props.readOnly}
        rows={10}
        style={props.style}
        onChange={(e) => {
          if (props.onChange) {
            props.onChange(e.target.value)
          }
        }}
        onKeyDown={(e) => {
          if (props.onKeyDown) {
            props.onKeyDown(e)
          }
        }}
      />
    </div>
  )
}

interface IInputLabelProps {
  labelText: string;
  required?: boolean;
}

export const InputLabel = (props: IInputLabelProps): JSX.Element => {
  return (
    <span className={style.fieldLabel}>{props.labelText}</span>
  )
}